import { render, staticRenderFns } from "./VxCellPermissionsRowCheckbox.vue?vue&type=template&id=1067596d&"
import script from "./VxCellPermissionsRowCheckbox.vue?vue&type=script&lang=js&"
export * from "./VxCellPermissionsRowCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports